export const GET_AREAS = 'GET_AREAS';

